import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_TRANSACTION_PROVISION_LIST,
    GET_TRANSACTION_PROVISION_SEARCH,
    GET_TRANSACTION_PROVISION_LINKED_AMOUNTS,
    GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS
} from "./actionTypes"

import {
    getTransactionProvisionListSuccess,
    transactionProvisionApiError,
    getTransactionProvisionSearchSuccess,
    getTransactionProvisionLinkedAmountsSuccess,
    getTransactionProvisionSettleLinkedAmountsSuccess

} from "./actions"

import {

    getTransactionProvisionList,
    getTransactionProvisionSearch,
    getTransactionProvisionLinkedAmount,
    getTransactionProvisionSettleLinkedAmount
} from "../../helpers/backend_helper/backend_helper"

function* onGetTransactionProvisionList({ payload: record })  {
    try {
        const response = yield call(getTransactionProvisionList,record)
        yield put(getTransactionProvisionListSuccess(response))
    } catch (error) {
        yield put(transactionProvisionApiError(error))
    }
}
function* onGetTransactionProvisionSearch({ payload: record }) {
    try {
        const response = yield call(getTransactionProvisionSearch, record)
        yield put(getTransactionProvisionSearchSuccess(response))
    } catch (error) {
        yield put(transactionProvisionApiError(error))
    }
}
function* onGetTransactionProvisionLinkedAmounts({ payload: record }) {
    try {
        const response = yield call(getTransactionProvisionLinkedAmount, record)
        yield put(getTransactionProvisionLinkedAmountsSuccess(response))
    } catch (error) {
        yield put(transactionProvisionApiError(error))
    }
}
function* onGetTransactionProvisionSettleLinkedAmounts({ payload: record }) {
    try {
        const response = yield call(getTransactionProvisionSettleLinkedAmount, record)
        yield put(getTransactionProvisionSettleLinkedAmountsSuccess(response))
    } catch (error) {
        yield put(transactionProvisionApiError(error))
    }
}

function* transactionProvisionManagementSaga() {
    yield takeEvery(GET_TRANSACTION_PROVISION_LIST, onGetTransactionProvisionList)
    yield takeEvery(GET_TRANSACTION_PROVISION_SEARCH, onGetTransactionProvisionSearch)
    yield takeEvery(GET_TRANSACTION_PROVISION_LINKED_AMOUNTS, onGetTransactionProvisionLinkedAmounts)
    yield takeEvery(GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS, onGetTransactionProvisionSettleLinkedAmounts)

}

export default transactionProvisionManagementSaga
